module.exports = __webpack_public_path__ + "img/avatar-person.a9ce91ce.svg";